import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateHandoverMutationVariables = Types.Exact<{
  input: Types.HandoverInput;
}>;


export type CreateHandoverMutation = { __typename?: 'mutation_root', create_handover?: { __typename?: 'CreateHandoverOutput', success: boolean, handover_id?: string | null, vendor_organization_id?: string | null, customer_organization_id?: string | null, user_invitation_id?: string | null, user_invitation_skipped_reason?: string | null, property_id?: string | null, error?: string | null, handover?: { __typename?: 'handover', id: any, project_name: string, project_description?: string | null, status: string, vendor_device_notes?: string | null, requester_notes?: string | null, created_at?: any | null, updated_at?: any | null } | null, vendor_organization?: { __typename?: 'organizations', id: any, name: string, email?: string | null, type?: string | null, organizationImageURL?: string | null } | null, customer_organization?: { __typename?: 'organizations', id: any, name: string, email?: string | null, type?: string | null, organizationImageURL?: string | null } | null, user_invitation?: { __typename?: 'user_invitations', id: any, email: string, role?: string | null, status: string, message?: string | null, properties_ids?: Array<string> | null, organization_id?: any | null, sender_id?: string | null, handover_id?: any | null, sender?: { __typename?: 'users', id: string, first_name: string, last_name: string, role?: string | null, email: string, organization_id?: any | null } | null } | null, property?: { __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, organization_id: any, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null } | null } | null };


export const CreateHandoverDocument = gql`
    mutation createHandover($input: HandoverInput!) {
  create_handover(input: $input) {
    success
    handover_id
    handover {
      id
      project_name
      project_description
      status
      vendor_device_notes
      requester_notes
      project_description
      created_at
      updated_at
    }
    vendor_organization_id
    vendor_organization {
      id
      name
      email
      type
      organizationImageURL
    }
    customer_organization_id
    customer_organization {
      id
      name
      email
      type
      organizationImageURL
    }
    user_invitation_id
    user_invitation_skipped_reason
    user_invitation {
      id
      email
      role
      status
      message
      properties_ids
      organization_id
      sender_id
      sender {
        id
        first_name
        last_name
        role
        email
        organization_id
      }
      handover_id
    }
    property_id
    property {
      id
      name
      address
      address_id
      standardized_address {
        id
        street_1
        street_2
        city
        state
        postal_code
        country
      }
      organization_id
    }
    error
  }
}
    `;
export type CreateHandoverMutationFn = Apollo.MutationFunction<CreateHandoverMutation, CreateHandoverMutationVariables>;

/**
 * __useCreateHandoverMutation__
 *
 * To run a mutation, you first call `useCreateHandoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHandoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHandoverMutation, { data, loading, error }] = useCreateHandoverMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateHandoverMutation(baseOptions?: Apollo.MutationHookOptions<CreateHandoverMutation, CreateHandoverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHandoverMutation, CreateHandoverMutationVariables>(CreateHandoverDocument, options);
      }
export type CreateHandoverMutationHookResult = ReturnType<typeof useCreateHandoverMutation>;
export type CreateHandoverMutationResult = Apollo.MutationResult<CreateHandoverMutation>;
export type CreateHandoverMutationOptions = Apollo.BaseMutationOptions<CreateHandoverMutation, CreateHandoverMutationVariables>;